<template>
  <div id="app" :class="{ 'homepage-bg': isHomePage }">
  <NavBar />

  <!-- Page content -->
  <router-view />

   <Footer />
     </div>
</template>

<script setup>
import NavBar from "@/components/NavBar.vue"; 
import Footer from "@/components/Footer.vue";
import { computed } from 'vue';
import { useRoute } from 'vue-router';
const route = useRoute();

const isHomePage = computed(() => {
  return route.path === '/' || route.name === 'Home' || route.path === '/home';
});

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
 
  text-align: center;
background-color:  #ffffff;

 
}
#app.homepage-bg {
  background-color: #fad0faff;
}

</style>
